import React, { useState } from 'react';
import axios from 'axios';

function ServiceForm() {
  const [formData, setFormData] = useState({
    type: '',
    partenariat: ''
  });

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/transformation`, formData);
    setFormData({ type: '', partenariat: '' });
    setShowModal(true); // Affiche le popup
  } catch (err) {
    alert(err.response?.data?.message || "Erreur de soumission");
  }
};


  const closeModal = () => setShowModal(false);

  const showHubspot = formData.type === 'visibilité';
  const showPackPME = formData.type === 'transformation digitale';
  const showPackMarketing = formData.type === 'marketing digital';

  return (
    <>
      <div style={{ display: 'flex', padding: '2rem', maxWidth: '1000px', margin: 'auto', gap: '2rem' }}>
        {/* Colonne gauche - Description */}
        <div style={{ flex: 1, background: '#f2f2f2', padding: '2rem', borderRadius: '10px' }}>
          <h2 style={{ marginBottom: '1rem' }}>Nos Services</h2>
          <p><strong>Visibilité :</strong> Augmentez votre présence digitale avec nos solutions innovantes.</p>
          <p><strong>Transformation digitale :</strong> Accompagne les PME vers le numérique avec nos packs dédiés.</p>
          <p><strong>Marketing digital :</strong> Référencement, réseaux sociaux, campagnes et plus encore.</p>
          <p>Faites votre choix ci-contre et découvrez ce que nous pouvons vous offrir.</p>
        </div>

        {/* Colonne droite - Formulaire */}
        <div
          style={{
            flex: 1,
            background: '#fff',
            border: '1px solid #ddd',
            padding: '2rem',
            borderRadius: '10px',
            marginTop: '2rem'
          }}
        >
          <h2 style={{ marginBottom: '1rem' }}>Choisissez un Service</h2>
          <form onSubmit={handleSubmit}>
            <label>
              Service :
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
                style={{ display: 'block', marginBottom: '1rem', width: '100%', padding: '0.5rem' }}
              >
                <option value="">-- Sélectionnez --</option>
                <option value="visibilité">Visibilité</option>
                <option value="transformation digitale">Transformation digitale</option>
                <option value="marketing digital">Marketing digital</option>
              </select>
            </label>

            {showHubspot && (
              <label>
                Partenariat avec Hubspot :
                <select
                  name="partenariat"
                  value={formData.partenariat}
                  onChange={handleChange}
                  required
                  style={{ display: 'block', marginBottom: '1rem', width: '100%', padding: '0.5rem' }}
                >
                  <option value="">-- Sélectionnez --</option>
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
              </label>
            )}

            {showHubspot && formData.partenariat === 'oui' && (
              <p style={{ marginBottom: '1rem' }}>
                🔗 <a href="https://www.hubspot.com/" target="_blank" rel="noopener noreferrer">Consultez le service Hubspot</a>
              </p>
            )}

            {showHubspot && formData.partenariat === 'non' && (
              <p style={{ marginBottom: '1rem' }}>
                🚀 Suivez notre site 👉 <a href="https://hoag-target.com" target="_blank" rel="noopener noreferrer">HOAG TARGET</a>
              </p>
            )}

            {showPackPME && (
              <div style={{ margin: '1rem 0' }}>
                <strong>📦 Pack PME :</strong> Transformation digitale complète pour petites entreprises.
              </div>
            )}

            {showPackMarketing && (
              <div style={{ margin: '1rem 0' }}>
                <strong>📦 Pack Marketing :</strong> Réseaux sociaux, contenu, SEO, campagnes publicitaires.
              </div>
            )}

            <button type="submit" style={{
              marginTop: '1rem',
              padding: '0.7rem 1.5rem',
              backgroundColor: '#007BFF',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}>
              Envoyer
            </button>
          </form>
        </div>
      </div>

      {/* ✅ Modal (Popup) */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '400px',
            textAlign: 'center',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
          }}>
            <h3 style={{ marginBottom: '1rem', color: 'green' }}>✅ Merci !</h3>
            <p>Nous vous enverrons la suite par email.</p>
            <button onClick={closeModal} style={{
              marginTop: '1.5rem',
              padding: '0.6rem 1.2rem',
              backgroundColor: '#007BFF',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}>
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ServiceForm;
